const fe = {
	enrolment: {
		title: "Påmeldingsskjema:",
		organisation_title: "Bedrifter/Grupper",
		personal_title: "For privatpersoner",
		details: "Detaljer",
		course_details: "Kursdetaljer",
		company_information: "Bestiller",
		course_type: "Kompetansegruppe",
		start_datetime: "Start sato/Tid",
		end_datetime: "Slutt dato/Tid",
		visiting_address: "Besøksadresse",
		invoice_address: "Fakturaadresse",
		participants: "Deltagere",
		p_course_id: "Kurs",
		p_first_name: "Fornavn",
		p_last_name: "Etternavn",
		p_email: "Epost",
		p_mobile: "Mobil",
		p_date_of_birth: "Født",
		p_address_street: "Gate",
		p_address_city: "By/Sted",
		p_address_state: "Fylke",
		p_address_zip: "Postnr",
		p_address_country: "Land",
		o_vat: "Orgnr",
		o_name: "Firmanavn",
		o_course_id: "Kurs",
		o_first_name: "Bestillers fornavn",
		o_last_name: "Bestillers etternavn",
		o_email: "Bestillers epost",
		o_reference: "Referanse/PO",
		o_customer_number: "Født",
		o_address_street: "Gate",
		o_address_city: "By/Sted",
		o_address_state: "Fylke",
		o_address_zip: "Postnr",
		o_address_country: "Land",
		invoice_email: "Faktura epost",
		comment: "Kommentar",
		submit: "Bekreft og meld på",
		submit_interest: "Meld interesse",
		pay_and_enrol: "Betal og meld på",
		no_of_participants: "Antall deltagere",
		enrolment_success: "Vellykket påmelding. Epost med bekreftelse er sendt.",
		enrolment_success_noemailsms: "Vellykket påmelding",
		enrolment_success_reservation: "Plasser reservert. Epost med bekreftelse er sendt.",
		enrolment_success_klarna: "Betalt med Klarna {date}",
		enrolment_error: "Påmelding feilet. Vennligst prøv igjen. Feilen er loggført",
		enrolment_duplicate: "Påmelding feilet. {names} er allerede påmeldt.",
		include: "Inkluderer:",
		additionals: "Tillegg:",
		select_course_types: "Velg opplæringskategori (Min: 1)",
		price: "Pris",
		price_additional: "Tillegg",
		price_total: "Total",
		all_seats_taken: "Kurset er dessverre fullt. Det er ikke mulig å melde seg på dette kurset.",
		course_full_register: "Kurset er dessverre fullt, men du kan melde din interesse",
		course_not_published_title: "Kurs er ikke publisert",
		course_not_published: "Påmeldingslink er ikke lenger gyldig",
		privacy_policy_title: "Personvernerklæring",
		privacy_consent_to: "Jeg godtar",
		privacy_notice: "Personvernerklæringen",
		privacy_close: "Lukk",
		enrol: "Påmelding",
		enrolment_cancel_ok: "Påmelding er kansellert.",
		enrolment_cancel_error: "Kunne ikke kansellere påmelding. Vennligst kontakt oppl.virksomhet.",
		interest_title: "Meld din interesse",
		interest_description: "Velg en eller flere kompetanser som du er interessert i. Vi vil varsle deg når kurs er tilgjengelig.",
		interest_select_courstypes: "Velg en eller flere kompetanser",
		interest_enrol_confirm: "Vil du beholde eleven på interesselista?",
		interest_comment_required: "Kompetansegruppe ikke valgt. Vennligst legg til kommentar.",
		enrolment_to: "Påmelding til",
		same_choices_for_all: "Like tilvalg for alle deltagere",
		select_organisation: "Bedrift / Gruppe",
		select_personal: "Privatperson",
		date_and_place: "Dato og sted",
		participants_unknown: "Deltagere er ukjent. Reserver plass.",
		delete_reservation: "Vil du slette reservasjon?",
	},
	course: {
		interest_form: "Meld interesse",
		upcoming_full_confirm: "Kurset er dessverre fullt. Velg annet kurs under eller Meld interesse",
	},
};
export default fe;